export default __webpack_public_path__ + "static/media/Paige_Loehr_AHV_In_Moms_We_Trust.735fd625.jpg";